import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
// @material-ui/icons
import Clear from "@material-ui/icons/Clear";
import Check from "@material-ui/icons/Check";
// core components
import styles from "assets/jss/material-dashboard-react/components/customInputStyle.js";

const useStyles = makeStyles(styles);

export default function CustomCheckbox(props) {
  	const classes = useStyles();
	const {
		formControlProps,
		inputProps,
		checkboxItems,
		selectedItems,
		error,
		success
	} = props;

	return (
		<FormControl {...formControlProps} className={formControlProps.className + " " + classes.formControl}>
			{checkboxItems.map(item => {
					const isSelected = selectedItems.find(selectedItem => selectedItem === item.key)
					return (
						<FormControlLabel {...inputProps} 
							control={
								<Checkbox
									checked={!!isSelected}
									value={item.key}
									name="checkedB"
									color="primary"
								/>
							}
							label={item.label}
							key={item.key}
						/>
					)
			})}
			{error ? (
				<Clear className={classes.feedback + " " + classes.labelRootError} />
			) : success ? (
				<Check className={classes.feedback + " " + classes.labelRootSuccess} />
			) : null}
		</FormControl>
	);
}

CustomCheckbox.propTypes = {
  id: PropTypes.string,
  inputProps: PropTypes.object,
  checkboxItems: PropTypes.array,
  formControlProps: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool
};
